const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_protected/ai/bots/$botId/conversations/$conversationId.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/_protected/ai/bots/$botId/conversations/$conversationId")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});